<template>
  <div class="home">
    <section class="hero  front">
      <div class="hero-body mb-0 pb-0">
        <div class="container">
          <div class="columns is-vcentered ">
            <div class="column is-half">
              <h1 class="title is-spaced">Flexible feedback widget for your website</h1>
              <h2 class="subtitle ">
                Make it easy for your users to tell you right on your website what they think about it with a feedback button, an inline widget, or a popup widget.
              </h2>
              <p>
                <router-link class="button is-primary is-medium cta" to="/register"><span>Create Widget for Free</span>
                <b-icon icon="arrow-right" size="is-small"/></router-link>
              </p>
            </div>

            <div class="column is-half has-text-centered">
              <img src="/img/feedback-widget/feedback-widget-survey.png" alt="feedback widget overview with branched survey responses">
           </div>
          </div>
        </div>
      </div>
    </section>
  <svg class="wave-sm" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#F9F9F9" fill-opacity="1" d="M0,128L60,133.3C120,139,240,149,360,160C480,171,600,181,720,202.7C840,224,960,256,1080,240C1200,224,1320,160,1380,128L1440,96L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"></path></svg>
     <section class="hero is-medium is-light">
      <div class="hero-body pt-6 ">
        <div class="container">
          <h2 class="title has-text-centered is-spaced">Same smooth 2-step process as with the newsletter integration</h2>
          <h3 class="subtitle has-text-centered mt-6">Directly inside your website or web app. User never leaves your page.</h3>
          <div class="columns is-centered">
            <div class="column is-4">
              <h3 class="subtitle">1. User rates</h3>
              <img src="img/feedback-widget/feedback-widget-vote.png" alt="feedback widget step 1 emoji voting">
            </div>
            <div class="column is-4">
              <h3 class="subtitle">2. User comments (optional)</h3>
              <img src="img/feedback-widget/feedback-widget-comment.png" alt="feedback widget step 2 emoji commenting">
            </div>
            <div class="column is-4">
              <h3 class="subtitle">Thank You</h3>
              <img src="img/feedback-widget/feedback-widget-thankyou.png" alt="feedback widget thank you notice">
            </div>
          </div>
        </div>
      </div>
    </section> 
    <section class="hero is-medium">
      <div class="hero-body">
        <div class="container">
          <h2 class="title has-text-centered is-spaced">Flexible feedback widget for all your needs!</h2>
          <h3 class="subtitle has-text-centered mb-6">Add it to your website or web app with a feedback button, inside your content or as a popup. Supports 3-thumbs or 5-smiley emojis voting.</h3>
          <div class="columns is-variable is-8 is-centered is-vcentered">
            <div class="column is-half">
              <h2 class="title is-4 is-spaced">Popup - Code or time triggered</h2>
              <p class="subtitle">
                An unobtrusive widget pops up in your site's bottom-left corner after a configurable time or manually triggered by your code.
              </p>
            </div>
            <div class="column is-half">
              <div class="content is-medium box has-text-centered">
                <img src="img/feedback-widget/feedback-widget-vote.png" alt="feedback widget step 1 emoji voting">
              </div>
            </div>
          </div>
          <div class="columns is-variable is-8 is-centered is-vcentered mt-6">
              <div class="column is-half">
              <div class="content is-medium box">
                <img src="img/feedback-widget/feedback-button.png" alt="feedback widget as feedback button">
              </div>
            </div>
            <div class="column is-half">
              <h2 class="title is-4 is-spaced">Feedback button</h2>

              <p class="subtitle">
The feedback button is a discreet tab visible on your website, and users can give you instant on-page feedback.</p>
<p class="subtitle">Users click on it, and the feedback widget shows at the center of the screen.

              </p>
              <p class="subtitle">
                <button id="feedletter-widget-button">Feedback</button>
                👉 Test live on the site
              </p>
            </div>

          </div>
          <div class="columns is-variable is-8 is-centered is-vcentered  mt-6">
            <div class="column is-half">
              <h2 class="title is-4 is-spaced">In-content widget</h2>
              <p class="subtitle">
Display the feedback widget right inside your content, like at the end of an article.

              </p>
              <p class="subtitle">
Collect reviews to get little stars on your Google search results to boost your SEO ranking!

              </p>

            </div>
            <div class="column is-half">
              <div class="content is-medium box">
                <img src="img/feedback-widget/feedback-widget-inline-article.png" alt="feedback widget in-content at the end of an article">
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero is-medium">
      <div class="hero-body ">
        <div class="container">
          <h2 class="title has-text-centered is-spaced">Showcase your social proof</h2>
          <h3 class="subtitle has-text-centered mb-6">The best way to get more users is to show what current users think of your work. </h3>

          <div class="columns is-variable is-8 is-centered is-vcentered  mt-6">
            <div class="column is-half">
              <div class="content is-medium box">
                <img src="img/richsnippet-feedletter.png" alt="get rich snippet support for star rating on google search">
              </div>
            </div>
            <div class="column is-half">
              <h2 class="title is-4 is-spaced">Improve Click-Through from search results</h2>
              <p class="subtitle">
Show your ratings on the search results on Google and increase your click-through rate (CTR) and boost your rankings.

              </p>
              <p class="subtitle">
Updates automatically, so you don’t need to worry about a thing. Simply insert the web rating widget and enable ratings when you embed.

              </p>
            </div>

          </div>
        </div>
      </div>
    </section>
        <svg class="wave-sm" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#4bbf73" fill-opacity="1" d="M0,128L60,133.3C120,139,240,149,360,160C480,171,600,181,720,202.7C840,224,960,256,1080,240C1200,224,1320,160,1380,128L1440,96L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"></path></svg>
    <section class="hero is-primary is-medium">
      <div class="hero-body">
        <div class="container">
          <h2 class="title has-text-centered">Even tech-toddler can set this up!</h2>
          <h3 class="subtitle has-text-centered">
Not a techie? No worries. FeedLetter is so easy to easy that even "tech-toddlers" could add it to their newsletter — if they had one. If you still need help, I’m always here!          </h3>
              <p class="has-text-centered">
                <router-link class="button is-primary cta is-medium" to="/register">Create Survey for Free</router-link>
              </p>
          
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "WebRatingFeaturePage",
  components: {},
    data: function () {
    return {
    };
  },
  mounted: function () {
    let flWidgetScript = document.createElement('script')
    flWidgetScript.setAttribute('src', 'https://feedletter.co/embed/widget.js')
    document.head.appendChild(flWidgetScript)
  },
  methods: {
  }
};
</script>

<style lang="scss">



</style>